const needParseHex = (deviceType) => {
  switch (deviceType) {
    case 1:
      return true;
    case 2:
      return false;
    case 3:
      return true;
    case 4:
      return true;
    default:
      return true;
  }
};

const dataAnalyseSimpleSignalService = (data, deviceType) => {
  const parseHex = needParseHex(deviceType);

  const dataAnalyse = {
    id: data.id,
    headers: ["TI"],
    simpleSignals: [],
  };

  data.simpleSignals.forEach((simpleSignal) => {
    const item = {
      time: simpleSignal.time,
      data: {},
    };

    Object.keys(simpleSignal.data).forEach((key) => {
      if (key !== "COOX" && key !== "COOY") {
        if (!dataAnalyse.headers.includes(key)) {
          dataAnalyse.headers.push(key);
        }

        if (key === "TI") {
          item.data[key] = {
            origenal: simpleSignal.time,
            value: simpleSignal.time,
          };
        } else {
          item.data[key] = getValue(simpleSignal.data, key, parseHex);
        }
      }
    });

    dataAnalyse.simpleSignals.push(item);
  });

  return dataAnalyse;
};

const getValue = (item, key, parseHex) => {
  const itemValue = {
    origenal: item[key],
    value: parseHex ? parseInt(item[key], 16) : parseFloat(item[key]),
  };

  return itemValue;
};

export default dataAnalyseSimpleSignalService;
